'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _createColorPalette = require('./createColorPalette'),
    _createColorPalette2 = _interopRequireDefault(_createColorPalette);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var magic = {
  1: '#f2f4f9',
  2: '#d2d9ed',
  3: '#b2bee0',
  4: '#91a3d4',
  5: '#7188c7',
  6: '#5773bf',
  7: '#425ba1',
  8: '#334a88',
  9: '#24386e',
  10: '#002244',
  inflection: 6
};
exports.default = (0, _createColorPalette2.default)(magic, 'magic');